import { Fragment } from 'react';
import Card from '../ui/Card';
import Closebutton from '../ui/Closebutton';
import Item from '../ui/Item';
import fries from '../../img/fries.jpeg';
import cheesefries from '../../img/cheesefries.jpeg';
import alfredofries from '../../img/alfredofries.jpeg';
import pasta from '../../img/pasta.jpeg';
import panini from '../../img/panini.jpeg';
import cesar from '../../img/cesar.jpeg';
const dummy_data = [
    {
        key:'d1',
        name:'Fries',
        price:60000,
        icon: fries ,
description:'single person',
    },
    {
        key:'d2',
        name:'Cheese Fries',
        price:70000,
        icon:cheesefries,
        description:'fries + cheese',
    },
    {
        key:'d3',
        name:'Alfredo Fries',
        price:70000,
        icon:alfredofries,
        description:'Fries + alfredo',
    },
    {
        key:'d4',
        name:'Pasta alfredo',
        price:95000,
        icon:pasta,
        description:' chiken + alfredo',
    },
    {
        key:'d5',
        name:'Panini bacon',
        price:85000,
        icon:panini,
        description:'2 pieces /4 pieces',
    },
    {
        key:'d6',
        name:'Cesar Salad',
        price:95000,
        icon:cesar,
        description:'grilled / spicy',
    },

] ;


const Coctails = (props) => {

    const fastfoodssList = dummy_data.map((fastfoods) => (
 
    <Item
      key={fastfoods.id}
      name={fastfoods.name}
      price={fastfoods.price}
      icon={fastfoods.icon}
      description={fastfoods.description}

    />
  ));
   
  return (
<Fragment>
    <Closebutton onClick={props.onClick}/>
<Card>

{fastfoodssList}

   </Card>
   </Fragment>
   )
}


export default Coctails ;